import { render, staticRenderFns } from "./GeneralReportTable.vue?vue&type=template&id=20d903d0&"
import script from "./GeneralReportTable.vue?vue&type=script&lang=js&"
export * from "./GeneralReportTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports